<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-10 15:54:25
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2025-10-13 10:53:23
-->
<template>
  <div class="innovative innovative-accuffrangio" :class="{textj: language != 'en'}" ref="accuffrangio">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffrangio.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <el-row :gutter="40" class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <el-col :span="12">
            <img class="" :src="$t('product.accuffrangio.list[0].img')" alt="" srcset="">
          </el-col>
          <el-col :span="12">
            <div class="innovative-item-title" v-html="$t('product.accuffrangio.list[0].title')"></div>
            <div class="p-t-46 p-b-60 textj">
              <p v-for="item, index in $t('product.accuffrangio.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel accuffrangio-characteristics">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.accuffrangio.list[1].img')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="{posabs: language != 'en'}">
          <div class="innovative-characteristics wh100">
            <div class="innovative-item-title p-l-15" v-html="$t('product.accuffrangio.list[1].title')"></div>
            <div class="flex flex_col justify_content_center hei100" :class="{'p-t-25': language == 'en'}">
              <div class="flex">
                <div class="flex flex_col align_items_center flex_1" v-for="item, index in $t('product.accuffrangio.list[1].des')" :key="index" :style="index == 1 ? (language == 'en' ? '' : 'padding: 0 6%;') : ''">
                  <div :class="['flex flex_col align_items_center']">
                    <div class="flex flex_col justify_content_center" style="height: 62px;">
                      <img class="" :src="item.img" alt="" srcset="">
                    </div>
                    <template v-if="language == 'en'">
                      <div v-if="clientWidth <= 1600 || clientWidth >= 2370" class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15" v-html="item.title.join(' ')"></div>
                      <div v-else class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="flex flex_col align_items_center flex_1" v-for="item, index in $t('product.accuffrangio.list[1].des')" :key="index" :style="language == 'en' ? 'padding: 0 8%;' : (index == 1 ? 'padding: 0 8%;' : '')">
                  <div>
                    <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accuffrangio-advantages">
        <div class="innovative-container">
          <div class="innovative-accuffrangio-m-h innovative-characteristics flex align_items_center">
            <div :class="language == 'en' ? 'flex_3' : 'flex_1'">
              <div class="trans-list">
                <div class="innovative-item-title p-l-15" style="" v-html="$t('product.accuffrangio.list[2].title')"></div>
                <div :class="['p-b-40 p-r-40', clientWidth > 1440 ? 'p-l-40' : '']">
                  <div class="flex p-t-40" v-for="item, index in $t('product.accuffrangio.list[2].des')" :key="index">
                    <div :class="['innovative-accuffrangio-m-h-img flex align_items_center justify_content_center']">
                      <img class="" :src="item.img" alt="" srcset="">
                    </div>
                    <div class="flex_1">
                      <div class="innovative-wrap-item-title fz-24 fontw p-b-20 p-t-15" v-html="item.title"></div>
                      <div>
                        <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="trans-list" :style="language == 'en' ? 'padding-right: 6%' : ''">
                <div class="innovative-item-title p-l-15 widauto ilblk p-r-100" style="" v-html="$t('product.accuffrangio.list[3].title')"></div>
                <div class="p-t-30">
                  <p class="innovative-characteristics-item" v-for="item, index in $t('product.accuffrangio.list[3].des')" :key="index" v-html="item"></p>
                </div>
              </div>
            </div>
            <div class="flex flex_col align_items_center" :class="language == 'en' ? 'flex_1' : ''">
              <img :src="$t('product.accuffrangio.list[2].img')" alt="" srcset="">
              <p class="textc" :class="{'color_008CDF': language != 'en'}" v-html="$t('product.accuffrangio.list[2].imgDes')"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="language == 'en'" class="p-t-58 accuffrangio-new">
        <div class="innovative-container">
          <div class="innovative-item-title p-l-15 widauto ilblk p-r-100" v-html="$t('product.accuffrangio.list[4].title')"></div>
          <div class="innovative-characteristics">
            <div class="flex flex_wrap">
              <div class="accuffrangio-new-item flex justify_content_center" v-for="item, index in $t('product.accuffrangio.list[4].des')" :key="index">
                <div v-if="index == 1">
                  <img :src="item.img" alt="" srcset="">
                </div>
                <div v-else class="accuffrangio-new-item-box">
                  <div class="img-box">
                    <img :src="item.img" alt="" srcset="">
                  </div>
                  <div class="textc">
                    <div class="accuffrangio-new-item-title">{{ item.title }}</div>
                  </div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in item.des" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </div>
            <div class="accuffrangio-new-sign">
              <p class="innovative-characteristics-item " v-html="$t('product.accuffrangio.list[4].sign')"></p>
            </div>
          </div>
        </div>
      </div> -->
      <div v-if="language == 'en'" class="p-t-30">
        <div class="innovative-container">
          <div class="innovative-item-title p-l-15 widauto ilblk p-r-100" v-html="$t('product.accuffrangio.list[5].title')"></div>
          <div class="accuffrangio-moreProduct flex align_items_center justify_content_center">
            <div v-html="$t('product.accuffrangio.list[5].des')"></div>
            <div class="p-l-20 p-r-20">
              <img class="wid100" :src="$t('product.accuffrangio.list[5].img')" alt="" srcset="">
            </div>
            <el-button class="moreProduct-btn" @click="openMoreProduct">{{ $t('product.accuffrangio.list[5].btn') }}</el-button>
          </div>
        </div>
      </div>
      <div class="innovative-container">
        <div class="innovative-wrap-item p-t-50 article">
          <div class="innovative-item-title p-l-15" v-html="$t('product.accuffrangio.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.accuffrangio.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      custom-class="accuffrangio-dialog"
      width="890px">
      <div class="accuffrangio-dialog-content flex">
        <div class="">
          <img :src="$t('product.accuffrangio.list[5].dialog.img')">
        </div>
        <div class="flex_1 p-l-40 p-r-40 p-t-30">
          <div class="dialog-more-product-title p-b-10">{{$t('product.accuffrangio.list[5].dialog.title')}}</div>
          <el-form ref="moreProductForm" :model="formData" :rules="rules" label-position="top" class="accuffrangio-dialog-form">
            <el-form-item :label="$t('product.accuffrangio.list[5].dialog.form.lastName.label')" prop="lastName">
              <el-input v-model="formData.lastName" :placeholder="$t('product.accuffrangio.list[5].dialog.form.lastName.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuffrangio.list[5].dialog.form.firstName.label')" prop="firstName">
              <el-input v-model="formData.firstName" :placeholder="$t('product.accuffrangio.list[5].dialog.form.firstName.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuffrangio.list[5].dialog.form.email.label')" prop="email">
              <el-input v-model="formData.email" :placeholder="$t('product.accuffrangio.list[5].dialog.form.email.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuffrangio.list[5].dialog.form.institutionName.label')" prop="institutionName">
              <el-input v-model="formData.institutionName" :placeholder="$t('product.accuffrangio.list[5].dialog.form.institutionName.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuffrangio.list[5].dialog.form.profession.label')" prop="profession">
              <el-select v-model="formData.profession" :placeholder="$t('product.accuffrangio.list[5].dialog.form.profession.placeholder')" class="wid100">
                <el-option :label="item.label" :value="item.value" v-for="item in profession" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('product.accuffrangio.list[5].dialog.form.product.label')">
              <el-input v-model="formData.product" :disabled="true" :placeholder="$t('product.accuffrangio.list[5].dialog.form.product.placeholder')"></el-input>
            </el-form-item>
          </el-form>
          <div class="textc p-t-5 p-b-10">{{ $t('product.accuffrangio.list[5].dialog.privacyPolicy[0]') }} <span @click="privacyStatus = true" class="cursor_pointer color_active">{{ $t('product.accuffrangio.list[5].dialog.privacyPolicy[1]') }}</span></div>
          <el-button class="accuffrangio-dialog-btn wid100" @click="handleSubmit('moreProductForm')">{{ $t('product.accuffrangio.list[5].dialog.btn.title') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog
      title=""
      :visible.sync="privacyStatus"
      custom-class="license-dialog"
      width="960px">
      <div class="license-dialog-content">
        <div class="p-b-20" v-for="item, index in $t('license.policy.list')" :key="index">
          <p v-for="$item, $index in item" :key="$index" v-html="$item"></p>
        </div>
      </div>
      <div class="license-dialog-time">{{ $t('license.policy.date') }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {
        lastName: '', // 名
        firstName: '', // 姓
        institutionName: '', // 机构名称
        profession: '', // 职业
        email: '', // 邮箱
        product: 'AccuFFRangio Plus CE'
      },
      rules: {
        lastName: [
          { required: true, message: this.$t('product.accuffrangio.list[5].dialog.form.lastName.required')[0], trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: this.$t('product.accuffrangio.list[5].dialog.form.firstName.required')[0], trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('product.accuffrangio.list[5].dialog.form.email.required')[0], trigger: 'blur' },
          { required: true, message: this.$t('product.accuffrangio.list[5].dialog.form.email.required')[1], pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, trigger: 'blur' }
        ],
        institutionName: [
          { required: true, message: this.$t('product.accuffrangio.list[5].dialog.form.institutionName.required')[0], trigger: 'blur' }
        ],
        profession: [
          { required: true, message: this.$t('product.accuffrangio.list[5].dialog.form.profession.required')[0], trigger: 'change' }
        ],
        product: [
          { required: true, message: this.$t('product.accuffrangio.list[5].dialog.form.product.required')[0], trigger: 'blur' }
        ]
      },
      profession: [
        { label: this.$t('license.formData.profession.physician.name'), value: this.$t('license.formData.profession.physician.value') },
        { label: this.$t('license.formData.profession.technician.name'), value: this.$t('license.formData.profession.technician.value') },
        { label: this.$t('license.formData.profession.scientificResearch.name'), value: this.$t('license.formData.profession.scientificResearch.value') },
        { label: this.$t('license.formData.profession.other.name'), value: this.$t('license.formData.profession.other.value') }
      ],
      privacyStatus: false // 隐私政策
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  },
  mounted () {
  },
  methods: {
    // 打开dialog
    openMoreProduct () {
      this.formData = {
        lastName: '',
        firstName: '',
        institutionName: '',
        profession: '',
        email: '',
        product: 'AccuFFRangio Plus CE'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.moreProductForm.resetFields()
      })
    },
    // 提交数据
    handleSubmit (formName) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          const parms = {
            lastName: this.formData.lastName,
            firstName: this.formData.firstName,
            institutionName: this.formData.institutionName,
            profession: this.formData.profession,
            email: this.formData.email,
            product: this.formData.product,
            type: 'en'
          }
          console.log(parms)
          this.$store.dispatch('app/submitAngio', parms).then((res) => {
            console.log(res)
            this.$refs[formName].resetFields()
            this.$message({
              dangerouslyUseHTMLString: true,
              duration: 5000,
              type: 'success',
              customClass: 'accuffrangio-dialog-message justify_content_center',
              message: this.$t('product.accuffrangio.list[5].dialog.btn.success')
            })
          }).catch((err) => {
            console.log(err)
            this.$refs[formName].resetFields()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
.pc.en .innovative-accuffrangio {
  .accuffrangio-dialog {
    border-radius: 20PX;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14PX;
      color: #333333;
    }
    .el-form-item {
      margin-bottom: 6PX;
    }
    .el-form-item__label {
      padding: 0;
      padding-top: 10PX;
      line-height: 24PX;
      color: #000000;
      font-size: 16PX;
      position: relative;
    }
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      color: #FF0909;
      font-size: 16PX;
      position: absolute;
      right: -16PX;
      top: 12PX;
    }
    .el-input__inner {
      border-radius: 0;
      border-top: none;
      border-left: none;
      border-right: none;
      color: #333333;
      padding: 0;
    }
    .el-input.is-disabled .el-input__inner {
      background-color: transparent;
    }
  }
  .license-dialog {
    height: 75vh;
    .el-dialog__body {
      height: calc(100% - 40PX);
      overflow: auto;
    }
    .license-dialog-content {
      // height: calc(100% - 40PX);
      color: #333333;
      word-break: initial;
    }
    .license-dialog-time {
      color: #8B8B8B;
      padding-top: 14PX;
    }
  }
}
.accuffrangio-dialog-message {
  background-color: rgba(0, 0, 0, 0.8);
  border-width: 0;
  min-width: 280PX;
  top: 50% !important;
  transform: translateX(-50%, -50%);
  .el-message__content {
    color: #ffffff;
  }
  .el-icon-success {
    color: #ffffff;
  }
}
</style>

<style lang="less" scoped>
.pc .innovative-accuffrangio {
  padding-bottom: 50PX;
  .innovative-characteristics {
    padding: 50PX 65PX;
  }
  .accuffrangio-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
  }
  .innovative-accuffrangio-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
    padding: 44PX 65PX;
    // font-size: 24PX;
    // font-weight: 600;
    .innovative-accuffrangio-m-h-img {
      width: 208PX;
    }
  }
  .accuffrangio-new {
    .innovative-characteristics {
      box-shadow: none;
      background: none;
      padding: 0 0 20PX;
    }
    .accuffrangio-new-item {
      width: 50%;
      padding: 20PX 4% 20PX 4%;
    }
    img {
      max-width: 480PX;
    }
    .accuffrangio-new-item-title {
      display: inline-block;
      min-width: 306PX;
      height: 45PX;
      line-height: 45PX;
      background: #48B7EB;
      border-radius: 23PX;
      color: #ffffff;
      text-align: center;
      margin-bottom: 10PX;
      font-size: 20PX;
    }
    .accuffrangio-new-item-box {
      width: 480PX;
      background: #FFFFFF;
      box-shadow: 0PX 4PX 12PX 4PX rgba(81,170,255,0.1);
      border-radius: 21PX;
      padding: 20PX 30PX;
      margin: 0 auto;
      margin-top: 80PX;
      .img-box {
        height: 150PX;
        position: relative;
      }
      img {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
    .accuffrangio-new-sign {
      padding-top: 30PX;
      .innovative-characteristics-item::before {
        content: '*';
        width: auto;
        height: auto;
        border-radius: 0;
        background: transparent;
        top: 2PX;
        left: 0;
        font-size: 16PX;
        color: #008CDF;
      }
    }
  }
}
.pc.en .innovative-accuffrangio {
  .accuffrangio-characteristics {
    background-image: url('~@/assets/images/innovate/AccuFFRangio/2.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .accuffrangio-moreProduct {
    background: rgba(157, 220, 255, 0.1);
    border-radius: 8PX;
    padding: 30PX 20PX;
    font-size: 16PX;
    .moreProduct-btn {
      background: #179BE3;
      border-radius: 10PX;
      height: 50PX;
      color: #ffffff;
    }
  }
  .dialog-more-product-title {
    color: #333333;
    font-size: 20PX;
    text-align: center;
  }
  .accuffrangio-dialog-btn {
    background: #179BE3;
    border-radius: 10PX;
    height: 50PX;
    color: #ffffff;
    font-size: 14PX;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1820PX) {
  .pc.zh .innovative-accuffrangio {
    .accuffrangio-characteristics {
      height: 600PX;
    }
  }
}
@media screen and (max-width: 1440PX) {
  .pc .innovative-accuffrangio {
    .innovative-accuffrangio-m-h {
      .innovative-accuffrangio-m-h-img {
        width: 160PX;
      }
    }
  }
}
</style>
